declare namespace JQuery {
    export interface Event {
        preventClearPopups(): void;

        isClearPopupsPrevented(): boolean;

        preventClick(): void;

        isClickPrevented(): boolean;
    }
}

$(function () {
    jQuery.Event.prototype.preventClearPopups = function () {
        const e = this.originalEvent;
        e.preventClearPopups = true;
    };

    jQuery.Event.prototype.isClearPopupsPrevented = function () {
        const e = this.originalEvent;
        return e && e.preventClearPopups;
    };

    jQuery.Event.prototype.preventClick = function () {
        const e = this.originalEvent;
        e.preventClick = true;
    };

    jQuery.Event.prototype.isClickPrevented = function () {
        const e = this.originalEvent;
        return e && e.preventClick;
    };
});
